module.exports = __webpack_public_path__ + "img/project1@2x.90bd661e.webp";